const normalizeSearch = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()

export function conditionTrack(track) {
	return { key: String(track.id ?? track.name ?? track.path), name: track.name, path: track.path }
}

export function conditionTrackTitle(track, translate) {
	const token = `tracks.${track.name}.title`
	const configured = track.name && translate(token)
	if (configured && configured !== token) return configured
	const patientToken = `condition_patient_type.${track.path || track.key}`
	const patientTitle = translate(patientToken)
	return patientTitle !== patientToken ? patientTitle : (track.name || track.path || track.key)
}

export function filterAndSearchConditions({
	conditions = [],
	searchQuery = '',
	selectedPatientTypes = [],
	selectedDiseaseCategories = []
}) {
	let filtered = conditions
	if (searchQuery) {
		const query = normalizeSearch(searchQuery)
		const matches = value => value && normalizeSearch(value).includes(query)
		filtered = filtered.filter(condition => {
			const titleMatch = matches(condition.title)
			const categoryMatch = matches(condition.category)
			const patientTypeMatch = (condition.patientTypes || []).some(pt =>
				matches(pt.title || pt.key)
			)
			const categoryKeyMatch = matches(condition.categoryKey)
			return titleMatch || patientTypeMatch || categoryKeyMatch || categoryMatch
		})
	}
	if (selectedPatientTypes.length > 0) {
		filtered = filtered.filter(condition =>
			(condition.patientTypes || []).some(type =>
				selectedPatientTypes.includes(type.key)
			)
		)
	}
	if (selectedDiseaseCategories.length > 0) {
		filtered = filtered.filter(condition => selectedDiseaseCategories.includes(condition.categoryKey))
	}
	return filtered
}
